export default __webpack_public_path__ + "static/media/loader.f87c4981.svg";